export default __webpack_public_path__ + "static/media/18.ca003aeb.jpg";